import React, { useState } from 'react'

import Icon from 'common/components/general/Icon'

import './FileUpload.less'

interface FileUploadProps {
  uploading: boolean
  accept?: string
  uploadTitle?: string
  choosedFileName?: string
  onFileChoosed: (file: File) => void
  onDeleteFileChoosed?: () => void
}

const FileUpload: React.FC<FileUploadProps> = ({
  onFileChoosed: fileChoosed,
  accept,
  uploadTitle = 'Upload',
  uploading,
  choosedFileName,
  onDeleteFileChoosed,
}) => {
  const [showDeleteFile, setShowDeleteFile] = useState<boolean>(false)
  return (
    <div>
      <label className="upload_document_button ant-btn">
        <input
          type="file"
          className="input_file"
          accept={accept}
          onChange={(e: any) => {
            if (e.target.files && e.target.files[0]) {
              fileChoosed(e.target.files[0])
            }
          }}
          value=""
        />
        <Icon type="upload" className="mr-8" />
        {uploadTitle}
      </label>
      {uploading && <p>uploading</p>}
      {choosedFileName && (
        <div
          className="choosed_file_name"
          onMouseEnter={() => setShowDeleteFile(true)}
          onMouseLeave={() => setShowDeleteFile(false)}
        >
          <div>
            <Icon type="far fa-paperclip" fontAwesome className="color-green-6 mr-8" />
            <span>{choosedFileName}</span>
          </div>
          {showDeleteFile && (
            <div>
              <Icon type="far fa-times" fontAwesome className="color-green-7 mr-8" onClick={onDeleteFileChoosed} />
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default FileUpload
